import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';

const Header = () => {

    return (
        <div className='bg-light position-sticky top-0 p-2 d-flex align-items-center justify-content-between'>
            <h1 className='ms-5 fs-1 fw-bold text-center bg-light mb-0'> COSMETiSTA..</h1>
            <div className='me-5'>

                <NavLink className={({ isActive }) => isActive ? "fw-bold text-dark p-2 ms-3 me-3 text-decoration-none" : "fw-bold text-secondary ms-3 me-3 p-2 text-decoration-none"} to='/'>HOME</NavLink>
                <NavLink className={({ isActive }) => isActive ? "fw-bold text-dark ms-3 me-3 p-2 text-decoration-none" : "fw-bold text-secondary ms-3 me-3 p-2 text-decoration-none"} to='/reviews'>REVIEWS</NavLink>
                <NavLink className={({ isActive }) => isActive ? "fw-bold text-dark ms-3 me-3 p-2 text-decoration-none" : "fw-bold text-secondary ms-3 me-3 p-2 text-decoration-none"} to='/dashboard'>DASHBOARD</NavLink>
                <NavLink className={({ isActive }) => isActive ? "fw-bold text-dark ms-3 me-3 p-2 text-decoration-none" : "fw-bold text-secondary ms-3 me-3 p-2 text-decoration-none"} to='/blog'>BLOG</NavLink>
            </div>




        </div>
    );
};

export default Header;